import styled from 'styled-components';
import { TableCellStyled } from '../styled';

const TableCellStarts = styled(TableCellStyled)`
  width: 120px;
`;

export default TableCellStarts;
